import Vue from "vue";


Vue.config.API_URL = "https://cp.dzenburo.ru/backend/api/";
Vue.config.IMAGE_URL = "https://cp.dzenburo.ru/backend";
Vue.config.BASE_URL = "https://cp.dzenburo.ru/";
Vue.config.TG_BOT = "dzenburbot";
Vue.config.currencys=["RUB"];
Vue.config.currencys_title={"RUB":"₽"};
Vue.config.currencys_chart=[
    {
        label: '₽',
        backgroundColor: ['#03acca', '#ff3709'],
        data: [0, 0]
    }

];
